import kypNeedBlurW from "assets/images/kypNeedBlurW.png";
import kypNeedBlurM from "assets/images/kypNeedBlurM.png";
import kypCriticalBlurW from "assets/images/kypCriticalW.png";
import kypCriticalBlurM from "assets/images/kypCriticalM.png";
import kypHealthyBlurW from "assets/images/kypHealthW.png";
import kypHealthyBlurM from "assets/images/kypHealthM.png";

const imgImport: Record<HealthStatus, { img: string; imgM: string }> = {
  Healthy: {
    img: kypHealthyBlurW,
    imgM: kypHealthyBlurM
  },
  Critical: {
    img: kypCriticalBlurW,
    imgM: kypCriticalBlurM
  },
  "Needs Attention": {
    img: kypNeedBlurW,
    imgM: kypNeedBlurM
  }
};

type HealthStatus = "Healthy" | "Critical" | "Needs Attention";

interface BlurScreenResultProps {
  type: HealthStatus;
}

export const BlurScreenResult = ({ type }: BlurScreenResultProps) => {
  const imgs = imgImport[type];

  return (
    <div className="-z-50">
      {/* Large screen image */}
      <img src={imgs?.img} alt="result" className="hidden sm:block" />

      {/* Small screen image */}
      <img src={imgs?.imgM} alt="result-mobile" className="block sm:hidden" />
    </div>
  );
};
